/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { Copy, Check } from 'lucide-react';
import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';

interface SelectorViewZoneProps {
    selectorCode: string;
}

const SelectorViewZone: React.FC<SelectorViewZoneProps> = ({ selectorCode }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = (e: React.MouseEvent) => {
        e.stopPropagation();
        navigator.clipboard.writeText(selectorCode).then(() => {
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 1500);
        });
    };

    return (
        <div className="selector-view-zone">
            <div className="selector-view-zone-content">
                <span className="selector-view-zone-code">{selectorCode}</span>
            </div>
            <div className="selector-view-zone-actions">
                <button
                    className={`selector-view-zone-copy-btn ${copied ? 'copied' : ''}`}
                    title="Copy selector to clipboard"
                    onClick={handleCopy}
                >
                    {copied ? <Check size={14} /> : <Copy size={14} />}
                </button>
            </div>
        </div>
    );
};

export default SelectorViewZone;

/**
 * Renders a React component into a DOM element
 * @param Component The React component to render
 * @param props Props to pass to the component
 * @returns DOM element containing the rendered React component
 */
const renderReactToElement = <P extends object>(Component: React.ComponentType<P>, props: P): HTMLElement => {
    const container = document.createElement('div');
    container.style.width = '100%';
    container.style.height = '100%';

    const root = createRoot(container);
    root.render(React.createElement(Component, props));
    return container;
};

export { renderReactToElement };
